const DOPPLER_SUBSCRIBE_URL = 'https://app2.fromdoppler.com/Lists/FormProcessing/FormSubscribe';
// Form for the "Suscriptores Newsletter" list (IdSubscribersList 28729170).
const DOPPLER_FORM_ID = 'jpTaZS91i43XrhpJCvA+dQ==';

// Doppler's dataType codes, as used by their own form-embed widget (vendor.js).
const DOPPLER_DATA_TYPE = {
  string: 2,
  email: 4,
};

// Field ids configured for this specific Doppler list/form.
const DOPPLER_FIELD = {
  email: 321,
  nombre: 319,
};

const DOPPLER_ERROR_MESSAGES = {
  2: 'Detectamos muchos intentos seguidos. Esperá un momento y volvé a intentar.',
  3: 'No pudimos validar el captcha. Volvé a intentar.',
  5: 'Ese email ya está suscripto y pendiente de confirmación.',
  6: 'No pudimos registrar ese email.',
  7: 'Ingresá un email válido.',
};

export async function sendNewsletterSignup({ nombre, email }) {
  const payload = {
    IdFormEncoded: DOPPLER_FORM_ID,
    fields: [
      { idField: DOPPLER_FIELD.email, dataType: DOPPLER_DATA_TYPE.email, value: email },
      { idField: DOPPLER_FIELD.nombre, dataType: DOPPLER_DATA_TYPE.string, value: nombre || '' },
    ],
  };

  const response = await fetch(DOPPLER_SUBSCRIBE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error('No pudimos registrar tu suscripción. Intentá nuevamente.');
  }

  const responseText = await response.text();
  let data = null;
  try {
    data = JSON.parse(responseText);
  } catch {
    data = null;
  }

  if (data?.errorCode) {
    throw new Error(DOPPLER_ERROR_MESSAGES[data.errorCode] || 'No pudimos registrar tu suscripción. Intentá nuevamente.');
  }

  return data;
}
